import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: "",
  list: [],
  byId: {},
};

const ProjectTypeSlice = createSlice({
  name: "ProjectType",
  initialState,
  reducers: {
    recieveProjectTypes(state, action) {
      state.list = action.payload
      state.byId = Object.fromEntries(action.payload.map(c => [c.id, c]));
    },
  },
});

export const {
  recieveProjectTypes
} = ProjectTypeSlice.actions

export default ProjectTypeSlice.reducer;
